import React, { Fragment } from "react";

export default function Main() {
  window.location.replace("https://byvide.com");
  return <Fragment></Fragment>;
}
